<template>
  <div class="CikamProgressContainer">
    <div v-if="showCikamChange">
      <div class="CikamChangeAmount">
        <div class="CikamText CikamChangeAmountText">
          {{ $t(`payment.betaling.text_cikam_dispensed_amount`) }}
        </div>
        <div class="CikamPrice CikamChangeAmountPrice">
          € {{ printPrice(cikamChange) }}
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="showCikamPaymentAmount" class="CikamPaymentAmount">
        <div class="CikamText CikamPaymentAmountText">
          {{ $t(`payment.betaling.text_cikam_payment_amount`) }}
        </div>
        <div class="CikamPrice CikamPaymentAmountPrice">
          € {{ printPrice(cikamPaymentAmount) }}
        </div>
      </div>
      <div v-if="showCikamInsertedAmount" class="CikamInsertedAmount">
        <div class="CikamText CikamInsertedAmountText">
          {{ $t(`payment.betaling.text_cikam_inserted_amount`) }}
        </div>
        <div
          class="CikamPrice CikamInsertedAmountPrice"
          :class="{
            'CikamInsertedAmountPrice-isValid': cikamInsertedAmountValid
          }"
        >
          € {{ printPrice(cikamInsertedAmount) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { toPrintable } from "@/utils/pricing";

export default {
  name: "Cikam",
  computed: {
    ...mapGetters({
      cikam_reponse: "CIKAM_RESPONSE"
    }),
    cikamPaymentAmount() {
      let paymentAmount = 0;
      if (this.cikamPaymentResponse["PaymentAmount"]) {
        paymentAmount = parseInt(this.cikamPaymentResponse["PaymentAmount"]);
      }
      return paymentAmount;
    },
    showCikamPaymentAmount() {
      return this.cikamPaymentResponse["PaymentAmount"];
    },
    cikamInsertedAmount() {
      let insertedAmount = 0;
      if (this.cikamPaymentResponse["InsertedAmount"]) {
        insertedAmount = parseInt(this.cikamPaymentResponse["InsertedAmount"]);
      }
      return insertedAmount;
    },
    showCikamInsertedAmount() {
      return this.cikamPaymentResponse["PaymentAmount"];
    },
    cikamInsertedAmountValid() {
      let paymentAmount = parseInt(this.cikamPaymentResponse["PaymentAmount"]);
      let insertedAmount = parseInt(
        this.cikamPaymentResponse["InsertedAmount"]
      );
      return insertedAmount >= paymentAmount;
    },
    showCikamChange() {
      let dispensedAmount = parseInt(
        this.cikamPaymentResponse["DispensedAmount"]
      );
      let changeRemaining = parseInt(
        this.cikamPaymentResponse["ChangeRemaining"]
      );
      changeRemaining = changeRemaining * -1;
      return (
        this.paymentIsfinishedOrWaitingRemovalOfCashOut &&
        (dispensedAmount > 0 || changeRemaining > 0)
      );
    },
    cikamChange() {
      let dispensedAmount = parseInt(
        this.cikamPaymentResponse["DispensedAmount"]
      );
      let changeRemaining = parseInt(
        this.cikamPaymentResponse["ChangeRemaining"]
      );
      changeRemaining *= -1;
      return dispensedAmount > 0 ? dispensedAmount : changeRemaining;
    },
    cikamPaymentResponse() {
      return this.cikam_reponse["details"] ? this.cikam_reponse["details"] : {};
    },
    statusCode() {
      return this.cikamPaymentResponse["StatusCode"];
    },
    paymentIsfinishedOrWaitingRemovalOfCashOut() {
      return this.statusCode == 1 || this.statusCode == 7;
    }
  },
  methods: {
    printPrice(value) {
      return toPrintable(value / 100);
    }
  },
  watch: {
    statusCode(newStatus) {
      console.log("watch statusCode newStatus=" + newStatus);
      if (newStatus === 7) {
        if (this.cikamChange > 0) {
          this.$emit("cashOut");
        }
      }
    }
  }
};
</script>

<style scoped>
.CikamProgressContainer {
  color: var(--component_Cikam_CikamProgressContainer_color);
  text-align: center;
  font-family: var(--component_Cikam_CikamProgressContainer_font-family);
}
.CikamText {
  font-size: var(--component_Cikam_CikamText_font-size);
  font-family: var(--component_Cikam_CikamText_font-family);
}
.CikamPrice {
  font-size: var(--component_Cikam_CikamPrice_font-size);
  font-family: var(--component_Cikam_CikamPrice_font-family);
}
.CikamPaymentAmount {
  margin-top: 40px;
}
.CikamInsertedAmount {
  margin-top: 40px;
}
.CikamChangeAmount {
  margin-top: 40px;
}

.CikamInsertedAmountPrice {
  color: var(--component_Cikam_CikamInsertedAmountPrice_color);
}
.CikamInsertedAmountPrice-isValid {
  color: var(--component_Cikam_CikamInsertedAmountPrice-isValid_color);
}
</style>
